export default {
    columns: [
        {
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.monthly-workday.year.description",//"Año",
          label: "wkt.admin.qbuilder.model.monthly-workday.year.text",//"Año",
          field: "year"
        },
        {
          field: "month",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.monthly-workday.month.description",//"Mes",
          label: "wkt.admin.qbuilder.model.monthly-workday.month.text",//"Mes"
        },
        {
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.monthly-workday.employee-id.description",//"Código interno trabajador",
          label: "wkt.admin.qbuilder.model.monthly-workday.employee-id.text",//"Código trabajador",
          field: "employeeId"
        },
        {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.monthly-workday.employee-firstname.description",//"Nombre",
          label: "wkt.admin.qbuilder.model.monthly-workday.employee-firstname.text",//"Nombre",
          field: "firstname"
        },
        {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.monthly-workday.employee-lastname.description",//"Apellidos",
          label: "wkt.admin.qbuilder.model.monthly-workday.employee-lastname.text",//"Apellidos",
          field: "lastname"
        },
                {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.monthly-workday.employee-id-number.description",//"Documento identificativo",
          label: "wkt.admin.qbuilder.model.monthly-workday.employee-id-number.text",//"Documento ID",
          field: "idNumber"
        },
        {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.monthly-workday.employee-external-id.description",//"Referencia externa",
          label: "wkt.admin.qbuilder.model.monthly-workday.employee-external-id.text",//"Referencia",
          field: "externalId"
        },
        {
          field: "username",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.monthly-workday.username.description",//"Nombre de usuario",
          label: "wkt.admin.qbuilder.model.monthly-workday.username.text",//"Usuario"
        },
        {
          field: "workplaceId",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.monthly-workday.workplace-id.description",//"Código del centro de trabajo",
          label: "wkt.admin.qbuilder.model.monthly-workday.workplace-id.text",//"Código centro trabajo"
        },
        {
          field: "workplaceName",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.monthly-workday.workplace-name.description",//"Nombre Centro de trabajo",
          label: "wkt.admin.qbuilder.model.monthly-workday.workplace-name.text",//"Centro trabajo"
        },
        {
          field: "departmentId",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.monthly-workday.department-id.description",// "Código del departamento",
          label: "wkt.admin.qbuilder.model.monthly-workday.department-id.text",//"Código departamento"
        },
        {
          field: "departmentName",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.monthly-workday.department-name.description",//"Nombre Departamento",
          label: "wkt.admin.qbuilder.model.monthly-workday.department-name.text",//"Departamento"
        },
        {
          field: "totalWorkHours",
          type: "TIME",
          desc: "wkt.admin.qbuilder.model.monthly-workday.total-work-hours.description",//"Horas objetivo a trabajar",
          label: "wkt.admin.qbuilder.model.monthly-workday.total-work-hours.text",//"H. a trabajar",
          formatter: 'formatTime'
        },
        {
          field: "totalHoursOff",
          type: "TIME",
          desc: "wkt.admin.qbuilder.model.monthly-workday.total-hours-off.description",//"Horas vacaciones",
          label: "wkt.admin.qbuilder.model.monthly-workday.total-hours-off.text",//"H. vacaciones",
          formatter: 'formatTime'
        },
        {
          field: "totalActivityWorkHours",
          type: "TIME",
          desc: "wkt.admin.qbuilder.model.monthly-workday.total-activity-work-hours.description",//"Horas de trabajo",
          label: "wkt.admin.qbuilder.model.monthly-workday.total-activity-work-hours.text",//"H. trabajo",
          formatter: 'formatTime'
        },
        {
          field: "adjustmentHours",
          type: "TIME",
          desc: "wkt.admin.qbuilder.model.monthly-workday.adjustment-hours.description",//"Ajuste horas de trabajo",
          label: "wkt.admin.qbuilder.model.monthly-workday.adjustment-hours.text",//"Ajuste H. T.",
          formatter: 'formatTime'
        },
        {
          field: "finalActivityWorkHours",
          type: "TIME",
          desc: "wkt.admin.qbuilder.model.monthly-workday.final-activity-work-hours.description",//"Total Horas Trabajadas",
          label: "wkt.admin.qbuilder.model.monthly-workday.final-activity-work-hours.text",//"Total H. T.",
          formatter: 'formatTime'
        },
        {
          field: "workBalance",
          type: "TIME",
          desc: "wkt.admin.qbuilder.model.monthly-workday.work-balance.description",//"Balance de horas trabajadas con respecto a las objetivo",
          label: "wkt.admin.qbuilder.model.monthly-workday.work-balance.text",//"Balance Horas",
          formatter: 'formatTime'
        },
        {
          field: "workBalanceHours",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.monthly-workday.work-balance_hours.description",//"Balance de horas trabajadas con respecto a las objetivo",
          label: "wkt.admin.qbuilder.model.monthly-workday.work-balance_hours.text",//"Balance en Horas",
          formatter: 'formatFloat'
        },
        {
          field: "totalActivityNonWorkHours",
          type: "TIME",
          desc: "wkt.admin.qbuilder.model.monthly-workday.total-activity-non-work-hours.description",//"Horas personales",
          label: "wkt.admin.qbuilder.model.monthly-workday.total-activity-non-work-hours.text",//"H. personales",
          formatter: 'formatTime'
        },
        {
          field: "adjustmentNonWorkHours",
          type: "TIME",
          desc: "wkt.admin.qbuilder.model.monthly-workday.adjustment-non-work-hours.description",//"Ajuste horas personales",
          label: "wkt.admin.qbuilder.model.monthly-workday.adjustment-non-work-hours.text",//"Ajuste H. P.",
          formatter: 'formatTime'
        },
        {
          field: "finalActivityNonWorkHours",
          type: "TIME",
          desc: "wkt.admin.qbuilder.model.monthly-workday.final-activity-non-work-hours.description",//"Total Horas Personales",
          label: "wkt.admin.qbuilder.model.monthly-workday.final-activity-non-work-hours.text",//"Total H. P.",
          formatter: 'formatTime'
        },
        {
          field: "extraHours",
          type: "TIME",
          desc: "wkt.admin.qbuilder.model.monthly-workday.extra-hours.description",//"Horas extra",
          label: "wkt.admin.qbuilder.model.monthly-workday.extra-hours.text",//"H. extra",
          formatter: 'formatTime'
        },
        {
          field: "adjustamentExtraHours",
          type: "TIME",
          desc: "wkt.admin.qbuilder.model.monthly-workday.adjustament-extra-hours.description",//"Ajuste horas extra",
          label: "wkt.admin.qbuilder.model.monthly-workday.adjustament-extra-hours.text",//"Ajuste H. E.",
          formatter: 'formatTime'
        },
        {
          field: "finalExtraHours",
          type: "TIME",
          desc: "wkt.admin.qbuilder.model.monthly-workday.final-extra-hours.description",//"Total Horas Extra",
          label: "wkt.admin.qbuilder.model.monthly-workday.final-extra-hours.text",//"Total H. E.",
          formatter: 'formatTime'
        },
        {
          field: "is_enabled",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.employee.enabled.description",    //"Habilitado",
          label: "wkt.admin.qbuilder.model.employee.enabled.text",  //"Habilitado",
          formatter: 'formatChoice',
          choices: [ { 'key':'0', 'value':'wkt.admin.common.no'/*'NO'*/ },
                     { 'key':'1', 'value':'wkt.admin.common.yes'/*'SI'*/ } ]
        }
      ],
}